import React from 'react';
interface InputFieldValueProps {
 value: InputFieldProps;
}

interface InputFieldProps {
  type: 'text' | 'number';
  label: string;
  text: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
}

const InputField: React.FC<InputFieldValueProps> = ({value}) => {
  const { type, label, text, onChange, placeholder, className, labelClassName, inputClassName } = value
  return (
    <div className={`flex flex-col ${className} `}>
      {label ? <label className={`open-sans-normal mb-2 ${labelClassName}`}>{label}</label> : null}
      <input
        type={type}
        value={text}
        onChange={onChange}
        placeholder={placeholder}
        className={`p-2 text-area-border rounded open-sans-normal  ${inputClassName}`}
      />
    </div>
  );
};

export default InputField;
